module.exports = __webpack_public_path__ + "static/media/BB_howtoboost_Desktop_SV.b1706392.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/BB_howtoboost_Desktop_SV.png
// module id = 711
// module chunks = 0